module.exports = __webpack_public_path__ + "static/media/3 13 byttelyd Starter testen 2.b84319e9.mp3";